module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-09.8721bc9e.svg";